//export const ENTRYPOINT = 'http://127.0.0.1:8000/api';
export const ENTRYPOINT = 'https://lynxworkflowapi.techno.lynxter.fr/api';
